export default "__VITE_ASSET__wXQm0LQW__"